import * as React from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { Operations } from './NavigatorData';
import { OperationContext } from './OperationContext';
import { FileData, TabSuffix } from './FilesContent';
import { DeltaXMLColors, DeltaJSONColors } from '../styling/DeltaColors';

const suffixColor = DeltaJSONColors.YELLOW; // gold
const suffixSize = '12px';

const styles = (theme: Theme) => {

  const origStyles = createStyles({
    categoryHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    secondaryBar: {
      zIndex: 0,
    },  
    tabBar: {
      backgroundColor: DeltaXMLColors.DARK_BACKGROUND,
      marginLeft: 0
    },
    [TabSuffix.None]: {},
    [TabSuffix.Raw]: {
      '&::after': {
        content: '"\u00A0\u00A0Raw"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },
    [TabSuffix.Diff]: {
      '&::after': {
        content: '"\u00A0\u00A0Diff"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },
    [TabSuffix.Graft]: {
      '&::after': {
        content: '"\u00A0\u00A0Graft"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },
    [TabSuffix.Patch]: {
      '&::after': {
        content: '"\u00A0\u00A0Patch"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },
    [TabSuffix.ThreeWayMerge]: {
      '&::after': {
        content: '"\u00A0\u00A0Three\u00A0Way\u00A0Merge"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },
    [TabSuffix.TwoWayMerge]: {
      '&::after': {
        content: '"\u00A0\u00A0Two\u00A0Way\u00A0Merge"',
        color: suffixColor,
        fontSize: suffixSize
      }
    },   
  }
  )
  return origStyles;
};


export interface FileTabsProps extends WithStyles<typeof styles> {
  tabGroupData: FileData[],
  tabValue: number,
  handleTabChange: (event: React.ChangeEvent<{}>, newValue: number, operationType: Operations) => void
}

export interface TabData {
  label: string
}

function FileTabs(props: FileTabsProps) {
  const { classes, tabGroupData, handleTabChange, tabValue} = props;
  const newTabValue = tabValue < tabGroupData.length? tabValue : 0;
  const opContextType = React.useContext(OperationContext).operationType;

  const handleTabValueChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    handleTabChange(event, newValue, opContextType);
  }

  return (
    <AppBar
      className={classes.secondaryBar}
      position="static"
      elevation={0}
    >
      <Tabs value={newTabValue} onChange={handleTabValueChange} className={classes.tabBar} selectionFollowsFocus>
        {tabGroupData.map(({ tabLabel, tabSuffix }) =>
          <Tab key={tabLabel} label={tabLabel} className={classes[tabSuffix]} />
        )
        }
      </Tabs>
    </AppBar>
  );
}

export default withStyles(styles)(FileTabs);
